module.exports = __webpack_public_path__ + "static/media/bahrain.43701308.jpg";